/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

function AdminFooter() {
  return (
    <footer className="footer pt-0">
      <Container fluid>
        <Row>
          <Col lg="6">
            <div className="copyright text-center text-lg-left text-muted">
              © {new Date().getFullYear()}{" "}
              <a
                className="font-weight-bold ml-1"
              >
                Next Level Funding
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}


export default AdminFooter;
